import { render, staticRenderFns } from "./security.vue?vue&type=template&id=bab4e4ae&scoped=true&lang=pug"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=bab4e4ae&prod&lang=scss&scoped=true&external"
import style1 from "./security.vue?vue&type=style&index=1&id=bab4e4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab4e4ae",
  null
  
)

export default component.exports